import classNames from 'classnames';
import { isNumber } from 'lodash';
import React from 'react';
import { Message, Scrollbars, SelectInput } from '@meitu/saas-ui';
import { MAX_FONT_SIZE, MIN_FONT_SIZE } from '@meitu/saas-editor-core/es/version-types';
import IconFont from '@meitu/xdesign-icon-font';
import { useLocaleStore } from '@/i18n';
import { FONT_SIZE_PRESETS } from './constants';
import './style.less';

type Props = {
    value: number;
    fontSizeOptions?: number[];
    disableMouseWheel?: boolean;
    onChange: (value: number) => void;
    onAfterChange?: (value: number) => void;
    onClick?: () => void;
    onOpenChange?: (open: boolean) => void;
};

export const FontSizeSelector: React.FC<Props> = ({
    value,
    fontSizeOptions = FONT_SIZE_PRESETS,
    disableMouseWheel = false,
    onChange,
    onAfterChange,
    onClick,
    onOpenChange,
}) => {
    const { $t } = useLocaleStore();

    const handleItemClick = (value: number, event: React.MouseEvent) => {
        event.stopPropagation();

        onChange(value);
        if (onAfterChange) onAfterChange(value);
    };

    const handleSelectInputChange = (value: number | null, afterChange: boolean) => {
        if (!isNumber(value)) return;

        if (value < MIN_FONT_SIZE || value > MAX_FONT_SIZE) {
            const errorText = $t((v, { r }) => r(v.textFontSize.limit, [MIN_FONT_SIZE, MAX_FONT_SIZE]));
            return Message.error(errorText);
        }

        onChange(value);
        if (afterChange && onAfterChange) onAfterChange(value);
    };

    const SelectInputContent = (
        <ul className="font-size-selector__list">
            <Scrollbars
                style={{
                    height: '242px', // TODO: 是否需要开放
                }}
            >
                {fontSizeOptions.map((size, idx) => {
                    return (
                        <li
                            key={idx}
                            className={classNames('font-size-selector__item', {
                                ['font-size-selector__item--active']: size === value,
                            })}
                            onClick={(event) => handleItemClick(size, event)}
                        >
                            {size}
                            {size === value ? (
                                <IconFont name="CheckBlack" color="var(--content-list-selected)" />
                            ) : null}
                        </li>
                    );
                })}
            </Scrollbars>
        </ul>
    );

    return (
        <div className="font-size-selector" onClick={onClick}>
            <SelectInput
                value={value}
                minVal={Number.MIN_SAFE_INTEGER}
                maxVal={Number.MAX_SAFE_INTEGER}
                trigger="click"
                width={92}
                height={34}
                decimalPoint={0}
                showStepBtn={true}
                onOpenChange={onOpenChange}
                onChange={(value: number | null) => handleSelectInputChange(value, false)}
                onAfterChange={(value: number | null) => handleSelectInputChange(value, true)}
                inputContent={SelectInputContent}
                disableMouseWheel={true}
            />
        </div>
    );
};
